// extracted by mini-css-extract-plugin
module.exports = {"row":"SocialAuthRow_row__QSWzZ","seg":"SocialAuthRow_seg__vXdrN","icon":"SocialAuthRow_icon__280ux","label":"SocialAuthRow_label__myE9L"};